import type { BlotterType } from 'models/blotters/BlotterType';
import type { Observable } from 'rxjs';
import { ignoreElements, map } from 'rxjs/operators';
import type { IHttpClient } from 'utils/http/httpClient.model';

export interface IPersistFilterStateApi {
  saveState(state: any, blotterType: BlotterType): Observable<void>;
}

export interface ILoadFilterStateApi {
  getState(blotterType: BlotterType): Observable<FilterPayload | undefined>;
}

export type IFilterStateApi = IPersistFilterStateApi & ILoadFilterStateApi;

export type FilterPayload = {
  data: unknown;
  version: 1;
};

export const filterStateApiConnector = (http$: IHttpClient): IFilterStateApi => ({
  saveState(data: any, blotterType: BlotterType) {
    const body: FilterPayload = { version: 1, data };
    return http$
      .post({
        url: `api/v1/blotter-filter-state/${blotterType}`,
        body,
      })
      .pipe(ignoreElements());
  },
  getState(blotterType: BlotterType) {
    return http$
      .getJSON<FilterPayload>({
        url: `api/v1/blotter-filter-state/${blotterType}`,
        headers: {
          Pragma: 'no-cache',
          'Cache-Control': 'no-cache',
        },
      })
      .pipe(map(({ status, payload }) => (status === 204 ? undefined : payload)));
  },
});
